// extracted by mini-css-extract-plugin
export default {"pagination":"_3KtNEOzYDnKXl0n9_XKxPm"};